<script lang="ts">
	interface Props {
		keys: string[]
		object: string
	}

	let { keys, object }: Props = $props()

	const getValue = (obj: string, path: string): any => {
		const parts: string[] = path.split('.')
		let current: any = obj
		for (let part of parts) {
			if (current === null || current === undefined) {
				console.log('Path not found:', path)
				return null
			}
			current = current[part]
		}
		return current
	}
</script>

{#each keys as key}
	<div class="json-field" style="padding-left: {20 * key.split('.').length}px">
		<strong class="json-key">{key}: </strong><span class="json-value">{getValue(object, key)}</span>
	</div>
{/each}

<style>
	.json-field {
		display: block;
		margin: 2px 0;
		color: #4a5568; /* Dark gray for text */
		font-family: 'Courier New', Courier, monospace;
	}

	.json-key {
		color: #2f855a; /* Green similar to chip bg, for keys */
		font-weight: bold;
	}

	.json-value {
		color: #718096; /* Lighter gray for values */
	}

	.json-field:hover {
		background-color: #e2e8f0; /* Light blue for hover */
		border-radius: 4px;
		padding: 2px 4px;
	}
</style>
